import {
    Button,
    CloseButtonViewOuter,
    H3,
    Modal,
    ModalCloseProps,
    SimpleCallback,
    SimpleText,
    Text,
    useMe,
} from 'platform-components';
import { UI_KIT_TEXT_TYPOGRAPHY, UI_KIT_HEADER_TYPOGRAPHY } from 'platform-components/constants';
import { useMetrika } from 'platform-components/src/utils/hooks/useMetrika';
import React from 'react';

interface Props {
    opened: boolean;
    slug: string;
    closeModal: SimpleCallback;
}

const CertificateCardModal = (props: Props) => {
    const { opened, slug, closeModal } = props;
    const me = useMe();
    const { sendGoal } = useMetrika();

    const handleButtonClick = () => {
        sendGoal('teacher_navigation_lk_unsolved_cert_ok', { teacher_id: me?.id, cert_id: slug });

        closeModal();
    };

    const handleCloseClick = () => {
        sendGoal('teacher_navigation_lk_unsolved_cert_close', { teacher_id: me?.id, cert_id: slug });

        closeModal();
    };

    return (
        <Modal
            Close={(closeProps: ModalCloseProps) => (
                <CloseButtonViewOuter {...closeProps} position={CloseButtonViewOuter.POSITION.ABSOLUTE} />
            )}
            hasClose
            mix="certificate-card__modal"
            onRequestClose={handleCloseClick}
            opened={opened}
            theme={Modal.THEMES.TEACHER}
        >
            <Modal.Header>
                <H3 id="teacherLK.card.modal.title" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMMedium} />
            </Modal.Header>
            <Modal.Content>
                <Text
                    id={`teacherLK.card.modal.description.${slug}`}
                    type={Text.TYPE.MARKDOWN}
                    typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}
                />
            </Modal.Content>
            <Modal.Footer>
                <Button
                    className="certificate-card__modal-button"
                    onClick={handleButtonClick}
                    view={Button.VIEW.ACTION}
                >
                    <SimpleText id="teacherLK.card.modal.okButtonText" />
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CertificateCardModal;
